import React, { useState, useMemo, useContext } from 'react'
import { get, put } from '../modules/fetch'
import { LOCALE } from '../constants/'
import { Link } from 'react-router-dom'
import model_array from '../modules/model_array'
import Loading from './Loading'
import Flag from './Flag'
import { ButtonGroup, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap'
import { If } from '../modules/helpers'
import Confirmation from './Confirmation'
import { isAfter, parseISO } from 'date-fns'

let loaded = false

const sortByLabel = (a, b) => a.label?.localeCompare(b.label) || 0

const SiteListContext = React.createContext({})
export const useSiteContext = () => useContext(SiteListContext)

const ObjectList = (props) => {
    const model = 'site'
    const model_definition = model_array.find((model_object) => model_object.name === model)
    const filter = props.location && props.location.search
    const properties = model_definition.list
    const [object_array, setObjectArray] = useState([])
    const [status, setStatus] = useState('not-loaded')
    const [display_delete_modal, setDisplayDeleteModal] = useState(false)
    const [display_restore_modal, setDisplayRestoreModal] = useState(false)
    const [modal_target, setModalTarget] = useState({})

    const is_trash = !!~filter.indexOf('active=0')
    const is_active = !!~filter.indexOf('active=1')
    const object_filter = (is_trash && ((object) => !object.active)) || (is_active && ((object) => object.active)) || (() => true)

    const setDisplayDeleteModalState = () => setDisplayDeleteModal(!display_delete_modal)
    const setDisplayRestoreModalState = () => setDisplayRestoreModal(!display_restore_modal)
    console.log({ status })

    const query_filter = filter + ((filter && '&') || '?') + 'scope=list' + ((props.filter && '&' + props.filter) || '')
    if (!loaded || loaded !== model + query_filter || status === 'not-loaded') {
        setStatus('loading')
        loaded = model + query_filter
        console.log('loading', loaded)
        get(model + query_filter)
            // .then(r => r.json())
            .then((r) => console.log(r) || r)
            .then((r) => {
                setObjectArray(r.sort(sortByLabel))
                setStatus('ready')
            })
    }

    const deleteObject = (id) => {
        put(model + '/' + id, { active: 0 })
            .then((r) => console.log(r))
            .then((r) => {
                const target = { ...object_array.find((obj) => obj.id === id), active: 0 }
                setObjectArray([...object_array.filter((obj) => obj.id !== id), target])
            })
    }
    const restoreObject = (id) => {
        put(model + '/' + id, { active: 1 })
            .then((r) => console.log(r))
            .then((r) => {
                const target = { ...object_array.find((obj) => obj.id === id), active: 1 }
                setObjectArray([...object_array.filter((obj) => obj.id !== id), target])
            })
    }

    const deleteModal = (id) => {
        console.log('deleteModal() called')
        setModalTarget(object_array.find((obj) => obj.id === id))
        setDisplayDeleteModal(true)
    }

    const restoreModal = (id) => {
        console.log('restoreModal() called')
        setModalTarget(object_array.find((obj) => obj.id === id))
        setDisplayRestoreModal(true)
    }

    const locale_site_array = useMemo(
        () =>
            object_array &&
            Object.keys(LOCALE).reduce((acc, locale) => {
                const candidate = acc.find((l) => l.locale === locale) || { locale, site_array: object_array.filter((s) => s.locale === locale) }
                candidate.site_array.length && acc.push(candidate)
                return acc
            }, []),
        [LOCALE, object_array]
    )

    const [site_version_array, setSiteVersionArray] = useState([])
    // const isLatest = site_version_array.length && (() => )
    const latestVersion = useMemo(
        () =>
            site_version_array.reduce((acc, item) => {
                if (!acc || isAfter(parseISO(item), parseISO(acc))) {
                    return item
                } else {
                    return acc
                }
            }, null),
        [site_version_array]
    )
    console.log({ latestVersion })

    return (
        <SiteListContext.Provider value={useMemo(() => ({ site_version_array, setSiteVersionArray, latestVersion }), [site_version_array])}>
            <If condition={status === 'loading'}>
                <Loading text="Fetching data" />
            </If>
            <If condition={display_delete_modal}>
                <Confirmation
                    isOpen={display_delete_modal}
                    toggle={setDisplayDeleteModalState}
                    confirm={() => deleteObject(modal_target.id)}
                    title={'Delete'}
                    text={'Are you sure you want to delete "' + model_definition.label(modal_target) + '"'}
                />
            </If>
            <If condition={display_restore_modal}>
                <Confirmation
                    isOpen={display_restore_modal}
                    toggle={setDisplayRestoreModalState}
                    confirm={() => restoreObject(modal_target.id)}
                    title={'Restore'}
                    text={'Are you sure you want to restore "' + model_definition.label(modal_target) + '"'}
                />
            </If>
            <If condition={status === 'ready'}>
                <React.Fragment>
                    {/* {locale_site_array.length} languages */}
                    {locale_site_array.map((l) => (
                        <React.Fragment key={l.locale}>
                            <div className="mb-3">
                                <h2 className="mb-0">
                                    <Flag locale={l.locale} className="mr-2" />
                                    {LOCALE[l.locale]}
                                </h2>
                                <small>
                                    {l.site_array.length} sites, {l.site_array.filter((s) => s.published).length} published
                                    <br />
                                    {l.site_array.reduce((acc, s) => acc + s.published_articles_count, 0)} published articles
                                </small>
                            </div>
                            <table className="table">
                                <tbody>
                                    {l.site_array.map((site) => (
                                        <tr key={`site-${site.id}`}>
                                            {properties.map((property, index) => {
                                                // console.log(property, typeof property)
                                                const value =
                                                    (typeof property === 'function' && property(site)) ||
                                                    (index === 0 && <Link to={`/${model}/edit/${site.id}`}>{site[property]}</Link>) ||
                                                    site[property]
                                                return <td key={`td-${site.id}-${property}`}>{value}</td>
                                            })}
                                            {/* <td><div className="btn btn-sm btn-danger" onClick={() => deletesite(site.id)}>delete</div></td> */}
                                            <td className="text-right">
                                                <ButtonGroup size="sm">
                                                    <Link className="btn btn-sm btn-secondary" to={`/${model}/edit/${site.id}`}>
                                                        Edit
                                                    </Link>
                                                    <UncontrolledButtonDropdown size="sm">
                                                        <DropdownToggle caret />
                                                        <DropdownMenu right>
                                                            <DropdownItem onClick={() => props.history.push(`/${model}/view/${site.id}`)}>View</DropdownItem>
                                                            {model_definition.dropdown &&
                                                                model_definition.dropdown.filter(Boolean).map((dropdown) => dropdown(site))}
                                                            <DropdownItem divider />
                                                            {(is_trash && <DropdownItem onClick={() => restoreModal(site.id)}>Restore</DropdownItem>) || (
                                                                <DropdownItem onClick={() => deleteModal(site.id)}>Delete</DropdownItem>
                                                            )}
                                                        </DropdownMenu>
                                                    </UncontrolledButtonDropdown>
                                                </ButtonGroup>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </React.Fragment>
                    ))}
                    <div className="text-center">
                        {model_definition && !model_definition.AddBtn && (
                            <a className="btn btn-primary" href={`/${model}/edit`}>
                                {(model_definition && model_definition.AddBtn_label) || 'Add'}
                            </a>
                        )}
                        {model_definition && model_definition.AddBtn && <model_definition.AddBtn />}
                    </div>
                </React.Fragment>
            </If>
        </SiteListContext.Provider>
    )
}

export default ObjectList
